import adminRoutes from "./admin"
import authRoutes from "./auth"
import { Layout, RType } from "./types"

const routes: Record<Layout, RType[]> = {
    "/admin": adminRoutes,
    "/auth": authRoutes
}

export default routes;
